/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { ChevronLeft } from 'lucide-react'
import { useTranslations } from 'next-intl'
import * as React from 'react'

import { useCarousel } from '@/components/e-commerce/kits/kit-gallery-carousel/Carousel'
import { cn } from '@/utils/css'

const CarouselPrevious = React.forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ className, ...props }, ref) => {
    const t = useTranslations('CarouselPrevious')
    const { scrollPrev, canScrollPrev } = useCarousel()

    return (
      <button
        type={'button'}
        ref={ref}
        className={cn(
          'absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center pointer-events-auto',
          'bg-white/50 rounded-full ring-1 ring-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:ring-offset-2',
          !canScrollPrev && 'hidden',
          className,
        )}
        disabled={!canScrollPrev}
        onClick={scrollPrev}
        {...props}
      >
        <ChevronLeft aria-hidden={'true'} className={'w-6 h-6 text-gray-700'} />
        <span className={'sr-only'}>{t('previousImage')}</span>
      </button>
    )
  },
)
CarouselPrevious.displayName = 'CarouselPrevious'

export { CarouselPrevious }
